import { groupBy } from 'lodash';
import { FC } from 'react';
import styles from './used-in-panels.module.scss';

export type UsedInPanelsProps = {
  items: {
    icon?: string;
    name: string;
    onClick?: () => void;
    subtitle?: string;
    title: string;
  }[];
};

export const UsedInPanels: FC<UsedInPanelsProps> = ({
  items
}) => {
  // Generic case to use in all new usage.
  const titleGroups = groupBy(items, 'title');

  return (
    <>
      {Object.entries(titleGroups).sort(([titleA], [titleB]) => {
        return titleA.localeCompare(titleB);
      }).flatMap(([title, titleGroup]) => {
        const subtitleGroups = groupBy(titleGroup, 'subtitle');
        return Object.entries(subtitleGroups).sort((
          [subtitleA],
          [subtitleB]
        ) => {
          return subtitleA.localeCompare(subtitleB);
        }).map(([subtitle, subtitleGroup]) => {
          const fullTitle = (subtitle !== 'undefined') ? (
            `${title} - ${subtitle}`
          ) : title;

          return (
            <div key={fullTitle} className={styles.panel}>
              <h4 className={styles.title}>{fullTitle}</h4>
              <ul className={styles.list}>
                {subtitleGroup.map((item) => {
                  const textDecoration = (item.onClick) ? 'underline' : 'none';
                  return (
                    <li key={item.name} onClick={item.onClick}>
                      <div>
                        {(!item.icon) ? null : (
                          <span className={styles.iconContainer}>
                            <i className={`fe icon-${item.icon}`}></i>
                          </span>
                        )}
                        <span style={{ textDecoration }}>{item.name}</span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        });
      })}
    </>
  );
};
